import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cn } from "../../lib/utils"

const Button = React.forwardRef(({ className, variant = "default", size = "default", asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  const variants = {
    default: "bg-burnt-sienna-500 text-white hover:bg-burnt-sienna-600",
    outline: "border border-burnt-sienna-500 text-burnt-sienna-500 hover:bg-burnt-sienna-50",
    ghost: "hover:bg-burnt-sienna-50 text-burnt-sienna-500",
  }
  
  const sizes = {
    default: "h-10 px-6 py-2",
    sm: "h-9 px-3",
    lg: "h-11 px-8",
    icon: "h-10 w-10",
  }

  return (
    <Comp
      className={cn(
        "inline-flex items-center justify-center rounded-md text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-burnt-sienna-500 disabled:pointer-events-none disabled:opacity-50",
        variants[variant],
        sizes[size],
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button }
